import {Component} from '@angular/core';

@Component({
  selector: 'uf-loading',
  templateUrl: './loading.component.html',
  standalone: true
})
export class LoadingComponent {
}
